import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { endpoints } from '../config/endpoints';
import { RequestQueueService } from '../services/requestQueue/request-queue.service';

@Injectable({
	providedIn: 'root'
})
export class ApiService {

	constructor(
		private http: HttpClient,
		private requestQueueService: RequestQueueService
	) { }

	get<T>(endpoint: string, options = {}): Observable<T> {
		return this.http.get<T>(environment.apiUrl + endpoint, options);
	}

	put<T>(endpoint: string, body: any, options = {}): Observable<T> {
		return from(this.requestQueueService.handleRequest<T>('PUT', environment.apiUrl + endpoint, body, options));
	}

	post<T>(endpoint: string, body: any, options = {}): Observable<T> {
		if (endpoint.endsWith(endpoints.login)) {
			return this.http.post<T>(environment.apiUrl + endpoint, body, options);
		}

		return from(this.requestQueueService.handleRequest<T>('POST', environment.apiUrl + endpoint, body, options));
	}

	patch<T>(endpoint: string, body: any, options = {}): Observable<T> {
		return from(this.requestQueueService.handleRequest<T>('PATCH', environment.apiUrl + endpoint, body, options));
	}

	delete<T>(endpoint: string, body: any, options = {}): Observable<T> {
		const url = environment.apiUrl + endpoint;

		return from(this.requestQueueService.handleRequest<T>('DELETE', url, body, options));
	}
}
